// extracted by mini-css-extract-plugin
export default {"root":"NavItem_root__CWP0h","absoluteBadge":"NavItem_absoluteBadge__aHEP6"};